<template lang='pug'>
  v-col(sm='12')
    v-row(no-gutters)
      v-col(style='padding: 0 20px')
        md-card
          md-card-header.md-card-header-icon.md-card-header-green
            .card-icon
              md-icon brush
            h4.title
              | {{ $t("webChannel.conversationReview.title") }}
          md-card-content
            form.form-horizontal(action method='post')
              .md-layout
                .md-layout-item(style='margin: auto;')
                  | {{
                  | $t(
                  | "webChannel.conversationReview.subitems.enableUserRatings"
                  | )
                  | }}
                .md-layout-item.md-form-label.md-size-15(style='padding: 0; margin: auto;' :class="{\
                'text-success': canalWebData.isConversationRatingActive,\
                'text-danger': !canalWebData.isConversationRatingActive\
                }")
                  | {{
                  | canalWebData.isConversationRatingActive
                  | ? $t("commonWords.enabled")
                  | : $t("commonWords.disabled")
                  | }}
                .md-layout-item.md-size-15
                  md-switch(v-model='canalWebData.isConversationRatingActive')
              .md-layout
                .md-layout-item.md-size-50(style='padding-left: 0')
                  md-field
                    label
                      | {{
                      | $t("webChannel.conversationReview.subitems.scale")
                      | }}
                    md-select(v-model='conversationQuantityFields')
                      span(v-for='(label, i) in labels' :key='i')
                        md-option(:value='i+1') {{ label }}
                .md-layout-item.md-size-50(style='padding-right: 0')
                  md-field
                    label
                      | {{
                      | $t(
                      | "webChannel.conversationReview.subitems.presentation"
                      | )
                      | }}
                    md-select(v-model='canalWebData.conversationRatingType')
                      md-option(value='stars') {{$t('serviceEvaluation.stars')}}
                md-field
                  label
                    | {{
                    | $t(
                    | "webChannel.conversationReview.subitems.introducingRatingMessage"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.introducingRatingMessage' md-autogrow)
                md-field
                  label
                    | {{
                    | $t(
                    | "webChannel.conversationReview.subitems.conversationRatingMessageExit"
                    | )
                    | }}
                  md-input(v-model='canalWebData.conversationRatingMessageExit')
                md-field(style='margin-top: 30px;')
                  label
                    | {{
                    | $t(
                    | "webChannel.conversationReview.subitems.messageRating"
                    | )
                    | }}
                  md-input(v-model='canalWebData.ratingRequestMessage')
                md-field
                  label
                    | {{
                    | $t(
                    | "webChannel.conversationReview.subitems.messageRatingGreeting"
                    | )
                    | }}
                  md-input(v-model='canalWebData.botRatingMessage')
                md-field
                  label
                    | {{
                    | $t(
                    | "webChannel.conversationReview.subitems.leaveChatModalMessage"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.leaveChatModalMessage' md-autogrow)
                md-field
                  label
                    | {{
                    | $t(
                    | "webChannel.conversationReview.subitems.operatorMessageRating"
                    | )
                    | }}
                  md-textarea(v-model='canalWebData.operatorMessageRating' md-autogrow)
                md-field
                  label
                    | {{
                    | $t(
                    | "webChannel.conversationReview.subitems.notAvaliableMessageRating"
                    | )
                    | }}
                  md-input(v-model='canalWebData.notAvaliableMessageRating')
</template>

<script>
export default {
  props: {
    canalWebData: {
      type: Object,
      required: true
    }
  },
  computed: {
    conversationQuantityFields: {
      get: function () {
        return this.canalWebData.conversationRatingLabels.length
      },
      set: function (nV) {
        this.canalWebData.conversationRatingLabels = this.labels.slice(0, nV)
      }
    }
  },
  data () {
    return {
      labels: ['☆', '☆☆', '☆☆☆', '☆☆☆☆', '☆☆☆☆☆']
    }
  }
}
</script>
